var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoding1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_15460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 41.7259 1.39906 43.125 3.125 43.125C4.84812 43.125 6.25 44.5269 6.25 46.25V58.75C6.25 67.3656 13.2594 74.375 21.875 74.375H28.125C29.8509 74.375 31.25 72.9759 31.25 71.25C31.25 69.5241 29.8509 68.125 28.125 68.125H21.875C16.7056 68.125 12.5 63.9194 12.5 58.75V46.25C12.5 43.8511 11.5944 41.6598 10.107 40C11.5944 38.3402 12.5 36.1489 12.5 33.75V21.25C12.5 16.0806 16.7056 11.875 21.875 11.875H28.125C29.8509 11.875 31.25 10.4759 31.25 8.75C31.25 7.02406 29.8509 5.625 28.125 5.625H21.875C13.2594 5.625 6.25 12.6344 6.25 21.25V33.75C6.25 35.4731 4.84812 36.875 3.125 36.875C1.39906 36.875 0 38.2741 0 40Z",
    fill: "#DAE5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.875 36.875C75.1519 36.875 73.75 35.4731 73.75 33.75V21.25C73.75 12.6344 66.7408 5.625 58.125 5.625H52.5C50.7741 5.625 49.375 7.02406 49.375 8.75C49.375 10.4759 50.7741 11.875 52.5 11.875H58.125C63.2944 11.875 67.5 16.0806 67.5 21.25V33.75C67.5 36.1489 68.4056 38.3402 69.893 40C68.4056 41.6598 67.5 43.8511 67.5 46.25V58.75C67.5 63.9194 63.2944 68.125 58.125 68.125H52.5C50.7741 68.125 49.375 69.5241 49.375 71.25C49.375 72.9759 50.7741 74.375 52.5 74.375H58.125C66.7408 74.375 73.75 67.3656 73.75 58.75V46.25C73.75 44.5269 75.1519 43.125 76.875 43.125C78.6009 43.125 80 41.7259 80 40C80 38.2741 78.6009 36.875 76.875 36.875Z",
    fill: "#DAE5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.125 18.125H40.625C38.8991 18.125 37.5 19.5241 37.5 21.25C37.5 22.9759 38.8991 24.375 40.625 24.375H58.125C59.8509 24.375 61.25 22.9759 61.25 21.25C61.25 19.5241 59.8509 18.125 58.125 18.125Z",
    fill: "#DAE5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 58.75C42.5 57.0241 41.1009 55.625 39.375 55.625H21.875C20.1491 55.625 18.75 57.0241 18.75 58.75C18.75 60.4759 20.1491 61.875 21.875 61.875H39.375C41.1009 61.875 42.5 60.4759 42.5 58.75Z",
    fill: "#DAE5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 33.75C18.75 35.4759 20.1491 36.875 21.875 36.875H39.375C41.1009 36.875 42.5 35.4759 42.5 33.75C42.5 32.0241 41.1009 30.625 39.375 30.625H21.875C20.1491 30.625 18.75 32.0241 18.75 33.75Z",
    fill: "#DAE5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.25 46.25C61.25 44.5241 59.8509 43.125 58.125 43.125H40.625C38.8991 43.125 37.5 44.5241 37.5 46.25C37.5 47.9759 38.8991 49.375 40.625 49.375H58.125C59.8509 49.375 61.25 47.9759 61.25 46.25Z",
    fill: "#DAE5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 24.375H28.125C29.8509 24.375 31.25 22.9759 31.25 21.25C31.25 19.5241 29.8509 18.125 28.125 18.125H21.875C20.1491 18.125 18.75 19.5241 18.75 21.25C18.75 22.9759 20.1491 24.375 21.875 24.375Z",
    fill: "#DAE5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.25 58.75C61.25 57.0241 59.8509 55.625 58.125 55.625H51.875C50.1491 55.625 48.75 57.0241 48.75 58.75C48.75 60.4759 50.1491 61.875 51.875 61.875H58.125C59.8509 61.875 61.25 60.4759 61.25 58.75Z",
    fill: "#DAE5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.125 30.625H51.875C50.1491 30.625 48.75 32.0241 48.75 33.75C48.75 35.4759 50.1491 36.875 51.875 36.875H58.125C59.8509 36.875 61.25 35.4759 61.25 33.75C61.25 32.0241 59.8509 30.625 58.125 30.625Z",
    fill: "#DAE5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 49.375H28.125C29.8509 49.375 31.25 47.9759 31.25 46.25C31.25 44.5241 29.8509 43.125 28.125 43.125H21.875C20.1491 43.125 18.75 44.5241 18.75 46.25C18.75 47.9759 20.1491 49.375 21.875 49.375Z",
    fill: "#DAE5FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_15460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding1);
export default __webpack_public_path__ + "static/media/coding 1.4db5fa04916bad179df46a86d22b2cca.svg";
export { ForwardRef as ReactComponent };